// @flow

import type {StatelessFunctionalComponent} from 'react';

import styled from '@emotion/styled';
import {Flex} from '@travel-frontend/ui-components';

export const Content: StatelessFunctionalComponent = styled(Flex)`
  width: 343px;
  text-align: center;
`;
